// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oW47","footer2":"footer_footer2__2E9Jt","menuactive":"footer_menuactive__1ypva","footItem":"footer_footItem__11x8O","footLink":"footer_footLink__37whd"};